<template>
    <div class="faq">
        <div class="container-fluid px-0">
            <div class="faq-header" :style="{backgroundImage: HERO_BLUE_PATTERN}">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div style="width: 925px; margin: 0 auto;">
                                <p class="h1b c16">CrossProm Help Center</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="faq-body">
                            <div>
                                <p class="h2b c1">FAQ</p>
                            </div>
                            <div class="accordion-place">
                                <div v-for="(item,index) in faqList" :key="index" class="mt-3">
                                    <b-button 
                                        v-b-toggle="'accordion-' + index"
                                        variant="primary" 
                                        class="w-100 c3 position-relative text-left"
                                        :style="winWidth < 991 ? buttonStyle : ''">
                                            {{item.title}}
                                    </b-button>
                                    <b-collapse :id="'accordion-' + index" class="mt-2 collapse-wrap">
                                        <b-card :style="winWidth < 991 ? cardStyle: ''">
                                            <ul class="p-0">
                                                <li class="c6o9">
                                                    {{item.description}}
                                                </li>
                                            </ul>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
​
​
        </div>
    </div>
</template>
​
<script>
    import {HERO_BLUE_PATTERN} from "../constants";

    export default {
        name: 'FAQ',
        mounted: function() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        data: function () {
            return {
                buttonStyle: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '700px !important',
                    paddingRight: '55px'
                },
                cardStyle: {
                    width: '700px'
                },
                HERO_BLUE_PATTERN: `url(${HERO_BLUE_PATTERN})`,
                faqList: [{
                        title: 'How can I add a new campaign to the platform?',
                        description: "You can add a new campaign from the Navigation bar, Published campaigns page under your account, as well as from the Dashboard when sending a cross-promotion request. After clicking on 'Add campaign' you'll be redirected to the Add campaign page. Follow the instructions and you can add a new campaign in 5 simple steps."
                    },
                    {
                        title: 'What are the pricing plans for the platform?',
                        description: 'The platform is free to use!'
                    },
                    {
                        title: 'Can I have more than one campaign registered on the platform?',
                        description: 'Yes, you can add all your campaigns registered on Kickstarter and Indiegogo to automate cross-promotions.'
                    },
                    {
                        title: "How can I edit my campaign's information?",
                        description: "You can edit your campaign's information by visiting your Published campaigns page from your account and by clicking the edit icon on your campaign card."
                    },
                    {
                        title: 'How can I change a funding campaign into InDemand?',
                        description: '‌‌If you have a campaign that went to InDemand after successful funding stage the platform will update this information automatically.'
                    },
                    {
                        title: 'What happens to my campaign if it has been cancelled/suspended on Kickstarter/Indiegogo?',
                        description: 'If your campaign is cancelled on Kickstarter or Indiegogo it gets the "Cancelled"/"Suspended" status on the platform. You still can send/receive cross-promotion requests and post them in your updates.'
                    },
                    {
                        title: 'What happens to my Kickstarter campaign when the funding stage is over?',
                        description: 'If the funding stage of your Kickstarter campaign is over and it is not going InDemand your campaign gets an "Ended" status. You still can use your updates to cross-promote with partner campaigns.'
                    },
                    {
                        title: 'How can I add/update dates?',
                        description: "You can add/update dates when adding a campaign to the platform or you can add them by visiting your campaign single page from your account's 'My campaigns' page and by clicking edit icon on your campaign card."
                    },
                    {
                        title: 'Can I change the update date?',
                        description: "Currently the platform doesn't allow changing the update date, however this is a coming feature to be added on the platform soon."
                    },
                    {
                        title: 'Can I change the number of update spots?',
                        description: 'Yes, you can change the number of predefined update spots.'
                    },
                    {
                        title: 'What is the maximum number of spots I can use?',
                        description: 'You can use up to 5 spots per update.'
                    },
                    {
                        title: 'Can I delete the update spot for which I already have an agreed cross-promotion?',
                        description: "You can't delete the busy update spot."
                    },
                    {
                        title: 'How can I send a cross-promotion request?',
                        description: '‌‌To send a cross-promotion request you need to have a registered campaign on the platform. You can send a cross-promotion request directly from the homepage or search page, from your partner campaign page and from the grid of your favorite campaigns. By clicking "Send request" you can choose the update date and spot of your partner campaign, include your update date and spot, and send your request.'
                    },
                    {
                        title: 'Can I send cross-prom requests to as many spots of the campaign as I find necessary?',
                        description: '‌‌You can send only one request per update date. But you can send multiple requests for different update dates.'
                    },
                    {
                        title: 'How do I accept a cross-prom request sent to me?',
                        description: '‌‌We will notify you about the new request! You can accept or decline requests on your dashboard, and see available update spots for each of your campaigns.'
                    },
                    {
                        title: 'If I have several campaigns, can they send cross-prom requests to each other?',
                        description: '‌‌Yes, they can.'
                    },
                    {
                        title: 'What if several campaigns apply for the same spot?',
                        description: '‌‌You will have an option to accept or decline each cross-prom request. Once you accept a certain request, other requests for the same spot will be automatically declined.'
                    },
                    {
                        title: 'Why does the platform need the category and tags of the campaign?',
                        description: "In order to provide your campaign's effective boost the platform suggests to cross-promote relevant campaigns that can give additional benefits to your backers. To suggest the best matching we use tags and categories of your campaign.",
                    },
                    {
                        title: 'Why do I need to verify my campaign?',
                        description: 'Your campaign verification is necessary to avoid possible fraudilent actions with your campaign.'
                    },
                    {
                        title: 'Can I save my draft campaign to edit and publish it later?',
                        description: 'Yes, once you start your campaign adding process on the platform, it is autosaved. You can save your draft campaign at any step you need. Further on you can edit your draft and publish it.'
                    },
                    {
                        title: 'Can I archive my campaign?',
                        description: "You can send your campaign to archive in case you don't have planned update dates and agreed cross-promotions. Later on you can restore it when needed."
                    },
                    {
                        title: 'Can I track a cross-promotion with each campaign on Google Analytics?',
                        description: 'Yes, you can track each cross-promotion with your partner campaign. When sending a cross-promotion offer the platform automatically generates a UTM link with the following source/medium: Crossprom/[partner campaign name].'
                    },
                    {
                        title: 'Can I contact the partner campaign owner if I need to discuss details of the cross-promotion?',
                        description: 'Yes, you can write a message to your partner campaign when sending a cross-promotion request.'
                    },
                    {
                        title: "If I don't like the terms of the cross-promotion offer sent by my partner do I have an option to send a counter-offer?",
                        description: 'If for some reason you want to change the cross-promotion terms such as update date or the preferred update spot, you can send a counter-offer with your terms for your partner campaign to approve. When the counter-offer is sent the previous cross-promotion request is cancelled.'
                    },
                    {
                        title: 'How do I know if my campaign is posted in a partner campaign’s update?',
                        description: 'We will send a notification that your campaign was mentioned in the update and provide a link to view the campaign update!'
                    },
                    {
                        title: "What if my partner campaign doesn't post my campaign as agreed?",
                        description: 'We will do everything on our side to get both of your campaigns posted. Whenever we receive complaints on a specific campaign for not posting cross-promotions as agreed, we will review them on a case by case basis and apply penalties. If someone breaks the cross-promotion agreement repeatedly, it will result in removing the campaign from the platform. '
                    },
                    {
                        title: 'Can I cancel the cross-promotion request I sent?',
                        description: 'Yes, you can cancel a sent cross-promotion request from the Dashboard.'
                    },
                    {
                        title: 'How can I copy the update information of my partner campaigns to add it into my update?',
                        description: "For each update date the platform automatically generates the copy of your partners' promotional materials that you can easily copy/export HTML code to paste into your crowdfunding page update editor. To find the cross-promo information to post visit My Updates tab in the Dashboard."
                    },
                    {
                        title: 'Do I get notifications from the platform to quickly respond to cross-promotion requests?',
                        description: 'Yes, you will receive notifications on the platform. Make sure to have the platform opened to be able to quickly respond to cross-promotion requests and incoming messages.'
                    },
                    {
                        title: 'How can I find relevant campaigns to do a cross-promotion with?',
                        description: 'Use our advanced search engine to find campaigns by name or by category. You can even filter campaigns by status and number of backers.'
                    }
                
                ]
            }
        },
        computed: {
            winWidth: function() {
                return window.innerWidth
            }
        }
    }
</script>
​
<style lang="scss" scoped>
    $icon-plus: 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o/img%2Fpluse.svg?alt=media&token=64624ca9-325e-435c-ad49-d009e1db2c95';
    div.faq {
        div.faq-header {
            padding-top: 40px;
            padding-bottom: 40px;
            background-size: cover;
        }
        div.faq-body {
            width: 925px;
            margin: 0 auto;
            margin-top: 70px;
            margin-bottom: 70px;
            div.accordion-place {
                width: 950px;
                margin-top: 70px;
                div.collapse-wrap {
                    margin-top: 0 !important;
                    div.card {
                        border: 0 !important;
                        border-top-left-radius: 0;
                        border-top-right-radius: 0;
                        div.card-body {
                            border-top: 1px solid #0000001a;
                            margin-left: 25px;
                            margin-right: 25px;
                            padding-left: 0;
                            ul {
                                width: 655px;
                                li {
                                    line-height: 28px;
                                    font-size: 15px;
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                }
                button {
                    height: 45px;
                    background: #FFFFFF;
                    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
                    padding-left: 25px;
                    font-size: 15px !important;
                    font-weight: bold;
                    border: 0;
                    &:focus {
                        border: 0;
                        box-shadow: none;
                    }
                    &[aria-expanded='true'] {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                        color: #727CF5 !important;
                        &::after {
                            content: url($icon-plus);
                            position: absolute;
                            left: 100%;
                            transform-origin: center center;
                            transform: translateX(-40px) rotate(45deg);
                        }
                    }
                    &::after {
                        content: url($icon-plus);
                        position: absolute;
                        left: 100%;
                        transform: translateX(-40px);
                        transition: all 0.3s ease;
                    }
                }
            }
        }
    }
</style>